import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { CopilotProposalId } from "@repo/app-types/entities/copilotProposal";
import type { RootState } from "../../app/store.js";

/**
 * The copilot proposals the open editor holds in its unsaved draft, and
 * whether it is saving them. The chat's proposal cards read it.
 */
export interface EditorProposalsState {
  proposalIds: readonly CopilotProposalId[];
  isSaving: boolean;
}

const initialState: EditorProposalsState = {
  proposalIds: [],
  isSaving: false,
};

const editorProposalsSlice = createSlice({
  name: "editorProposals",
  initialState,
  reducers: {
    reportEditorProposals: (
      _state,
      action: PayloadAction<EditorProposalsState>,
    ) => action.payload,
    clearEditorProposals: () => initialState,
  },
});

export const { reportEditorProposals, clearEditorProposals } =
  editorProposalsSlice.actions;
export const editorProposalsReducer = editorProposalsSlice.reducer;

/** Where a proposal stands in the open editor, if the editor holds it. */
export function selectEditorProposalState(
  state: RootState,
  proposalId: CopilotProposalId,
): "viewing" | "saving" | undefined {
  const { proposalIds, isSaving } = state.editorProposals;
  if (!proposalIds.includes(proposalId)) {
    return undefined;
  }
  return isSaving ? "saving" : "viewing";
}
